import { SET_APP_SETTING } from "../actions/action";

const defaultState = {
  appSettings: {},
};

const appSettingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_APP_SETTING:
      return { ...state, appSettings: action.payload };
    default:
      return state;
  }
};

export default appSettingReducer;
